module.exports = __webpack_public_path__ + "static/media/create-account.02e7a107.png";